import {Component, Input} from '@angular/core';
import {ValidationErrors} from '@angular/forms';

@Component({
  selector: 'validation-error',
  template: `
    <div *ngIf="showError && errorKey">
      <span [ngSwitch]="errorKey">
        <ng-container *ngSwitchCase="'required'">
          {{'common.validation.required' | translate}}
        </ng-container>
        <ng-container *ngSwitchCase="'pattern'">
          {{'common.validation.invalid' | translate}}
        </ng-container>
        <ng-container *ngSwitchCase="'pastDate'">
          {{'common.validation.timeAlarm' | translate}}
        </ng-container>
        <!--<ng-container *ngSwitchCase="'minlength'">-->
          <!--{{'validation.' + name | translate}}-->
          <!--{{'validation.isLess' | translate}}-->
          <!--{{errors[errorKey]?.requiredLength}}-->
          <!--{{'validation.characters' | translate}}.-->
        <!--</ng-container>-->

        <!--<ng-container *ngSwitchCase="'phonePattern'">-->
          <!--{{'validation.phoneIsInvalid' | translate }}.-->
        <!--</ng-container>-->
        <!--<ng-container *ngSwitchCase="'timePattern'">-->
          <!--{{'validation.timeAlarm' | translate }}-->
        <!--</ng-container>-->
        <ng-container *ngSwitchCase="'numberNotSupportedCreditCard'">
          {{'common.validation.cardNumberIsNotSupported' | translate }}
        </ng-container>
        <!--<ng-container *ngSwitchCase="'invalidCreditCard'">-->
          <!--{{'errors.wrongCardNumber' | translate }}-->
        <!--</ng-container>-->
        <!--<ng-container *ngSwitchCase="'expiryDatePattern'">-->
          <!--{{'errors.cardExpireError' | translate }}-->
        <!--</ng-container>-->
      </span>
    </div>
  `,
})

export class ValidationErrorComponent {
  @Input() errors: ValidationErrors | null;
  @Input() showError: boolean;
  @Input() name: string;
  // @Input() qaAttribute: string;

  get errorKey() {
    if (!this.errors) {
      return false;
    }
    return Object.keys(this.errors)[0];
  }
}



// WEBPACK FOOTER //
// ./src/app/components/form-fields/validation-error/validation-error.component.ts